export const content = `
<div>
    <slot v-if="data.keepContent"></slot>
    <div v-for="item in data.results" class="recent-posts__cell">
        <div class="article-tile__wrapper">
            <a class="article-tile__link" href="#" :href="item.url">
                <div class="article-tile__image-container">
                    <img src="https://placehold.it/305x180" class="article-tile__image" :src="item.image" :alt="item.imageAltText" />
                </div>
                <p class="article-tile__title" v-html="item.title"></p>
                <p class="article-tile__info">{{item.type}} / {{item.info}}</p>
            </a>
        </div>
    </div>
</div>
`;

export const paginator = `
<div v-if="(data.firstLoad && isShow) || data.nextPage">
    <slot></slot>
</div>
`;
